﻿export const ExtensionsNS: "Serenity.Extensions" = "Serenity.Extensions";
export const nsExtensions: "Serenity.Extensions." = "Serenity.Extensions.";
export const ReportingNS: "Serenity.Reporting" = "Serenity.Reporting";
export const nsReporting: "Serenity.Reporting." = "Serenity.Reporting.";